import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  link_url: string | null;
  is_read: boolean;
  created_at: string;
  expires_at: string | null;
}

function authHeaders(token: string) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function getNotifications(token: string, unreadOnly?: boolean): Promise<Notification[]> {
  const params = unreadOnly ? '?unread_only=true' : '';
  const response = await axios.get(`${API_BASE_URL}/notifications${params}`, authHeaders(token));
  return response.data.data;
}

export async function getUnreadCount(token: string): Promise<number> {
  const response = await axios.get(`${API_BASE_URL}/notifications/unread-count`, authHeaders(token));
  return response.data.data.count;
}

export async function markAsRead(id: string, token: string): Promise<void> {
  await axios.put(`${API_BASE_URL}/notifications/${id}/read`, {}, authHeaders(token));
}

export async function markAllAsRead(token: string): Promise<void> {
  await axios.put(`${API_BASE_URL}/notifications/read-all`, {}, authHeaders(token));
}
